'use client'

import { ThemeProvider as NextThemesProvider } from 'next-themes'
import type { ComponentProps, FC, ReactElement } from 'react'

type ThemeProviderProps = ComponentProps<typeof NextThemesProvider>

const ThemeProvider: FC<ThemeProviderProps> = ({ children, ...props }): ReactElement => (
	<NextThemesProvider
		attribute="class"
		defaultTheme="system"
		enableSystem
		storageKey="theme"
		disableTransitionOnChange
		{...props}
	>
		{children}
	</NextThemesProvider>
)

export default ThemeProvider
